import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import HeroNotice from "./components/HeroNotice";
import FeaturesSections from "./components/FeaturesSections";
import BottomSections from "./components/BottomSections";
import ServicesPage from "./pages/ServicesPage";
import HealingTechniquesPage from "./pages/HealingTechniquesPage";
import ContactPage from "./pages/ContactPage";
import BlogPostPage from "./pages/BlogPostPage";
import { BlogPage, PoliciesPage, ReviewPage } from "./pages/OtherPages";

const HomePage = () => (
  <>
    <Navbar />
    <HeroNotice />
    <FeaturesSections />
    <BottomSections />
  </>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/healing-techniques" element={<HealingTechniquesPage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/:slug" element={<BlogPostPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/policies" element={<PoliciesPage />} />
          <Route path="/review" element={<ReviewPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
